import "../scss/page.scss";

import "../scss/singleshop.scss";

import "./scripts/slick/singleshop.js";
/**
 * Open PhotoSwipe when clicking the main gallery image.
 * WooCommerce only wires image clicks when zoom or flexslider is disabled;
 * with both enabled, only .woocommerce-product-gallery__trigger works.
 */
jQuery( function ( $ ) {
	$( document.body ).on(
		"wc-product-gallery-after-init",
		".woocommerce-product-gallery",
		function ( event, galleryElement ) {
			const $gallery = $( galleryElement );
			const gallery = $gallery.data( "product_gallery" );

			if ( ! gallery || ! gallery.photoswipe_enabled ) {
				return;
			}

			$gallery.off( "click.uptalentPhotoswipe" );

			$gallery.on(
				"click.uptalentPhotoswipe",
				".woocommerce-product-gallery__wrapper .woocommerce-product-gallery__image",
				function ( clickEvent ) {
					if (
						$( clickEvent.target ).closest(
							".woocommerce-product-gallery__trigger"
						).length
					) {
						return;
					}

					const $link = $( this ).find( "a" ).first();

					if ( ! $link.length ) {
						return;
					}

					clickEvent.preventDefault();

					const photoSwipeEvent = $.Event( "click", {
						target: $link.get( 0 ),
						currentTarget: $link.get( 0 ),
					} );

					gallery.openPhotoswipe( photoSwipeEvent );
				}
			);
		}
	);
} );

/**
 * Zoom image alt (#204): WooCommerce adds the zoom image with an empty alt (it is
 * aria-hidden, a copy of the main image). Give it the main image's alt so audits
 * don't flag it; it stays hidden from screen readers.
 */
document.querySelectorAll( ".woocommerce-product-gallery" ).forEach( function ( gallery ) {
	new MutationObserver( function () {
		gallery.querySelectorAll( "img.zoomImg" ).forEach( function ( zoomImg ) {
			const mainImg = zoomImg.parentElement.querySelector( "img:not(.zoomImg)" );
			const alt = mainImg ? mainImg.getAttribute( "alt" ) : "";

			if ( alt && zoomImg.getAttribute( "alt" ) !== alt ) {
				zoomImg.setAttribute( "alt", alt );
			}
		} );
	} ).observe( gallery, { childList: true, subtree: true, attributes: true, attributeFilter: [ "alt" ] } );
} );
